module.exports = __webpack_public_path__ + "34736292/img/settings-ico.a214628d.svg";